import confirmOrder from './order/confirmOrder'

export default {
  confirmOrder,
}
